import {
  Box,
  CircularProgress,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  menuRecipeAndProductionFeatures,
  professionalAccountantFeatures,
  professionalAndBenefitsAccountantFeatures,
} from "src/pages/add-sales/constants";
import ItemInfo from "src/pages/add-sales/branch-package-popup/info-item";

interface IProps {
  setSelectedPackage: Function;
  selectedPackage: number | string;
  packagesList: any[];
  isFetching: boolean;
}

const PackagePopup = (props: IProps) => {
  const { selectedPackage, setSelectedPackage, packagesList, isFetching } =
    props;
  const { t } = useTranslation("addSales");
  const { t: generalT } = useTranslation("general");

  const featuresList = [
    professionalAccountantFeatures,
    professionalAndBenefitsAccountantFeatures,
    menuRecipeAndProductionFeatures,
  ];

  const featuresNames = [
    "professionalAccountant",
    "professionalAndCostAccountant",
    "menuRecipeProductionPackageName",
  ];

  const featuresDescriptions = [
    "professionalAccountantDescription",
    "professionalAndCostAccountantDescription",
    "menuRecipeProductionPackageDescription",
  ];

  return (
    <Stack
      spacing={3}
      sx={{
        width: { xs: "100%", sm: 1047 },
      }}
    >
      <Box>
        {isFetching ? (
          <Box
            minHeight={"500px"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={{ xs: 1, lg: 3 }}>
            {packagesList
              .filter((packToFilter: any) => packToFilter.status)
              .slice(0, 3)
              .map((pack: any, index: number) => {
                return (
                  <Grid key={pack.id} item xs={12} md={4}>
                    <Paper
                      elevation={2}
                      sx={{
                        p: { xs: 2, lg: 4 },
                        width: "100%",
                        borderRadius: "20px",
                        boxShadow: "none",
                        mb: "29px",
                        border:
                          selectedPackage === pack.id
                            ? "2px solid #FF8D3F"
                            : "2px solid #EAEFF4",
                        cursor: "pointer",
                      }}
                      onClick={() => setSelectedPackage(pack.id)}
                    >
                      <Box
                        display={"flex"}
                        justifyContent={"space-between"}
                        mb={"16px"}
                        flexDirection={{ xs: "column", sm: "row" }}
                      >
                        <Typography
                          fontSize={"36px"}
                          color={"#2B3674"}
                          lineHeight={"44px"}
                          fontWeight={700}
                          mb={{ xs: 2, md: 0 }}
                        >
                          {pack.price} {t("sar")}.{" "}
                          <Typography
                            component={"span"}
                            color={"#474747"}
                            fontSize={"20px"}
                            fontWeight={400}
                            lineHeight={"28px"}
                          >
                            {t("monthly")}
                          </Typography>
                        </Typography>
                      </Box>
                      <Typography
                        color={"#2B3674"}
                        fontSize={"16px"}
                        fontWeight={700}
                        lineHeight={"28px"}
                        mb={1}
                      >
                        {t(featuresNames[index])}
                      </Typography>
                      <Typography color={"#474747"} lineHeight={"20px"}>
                        {t(featuresDescriptions[index])}
                      </Typography>
                      {/* divider */}
                      <Box
                        width={"100%"}
                        height={"1px"}
                        bgcolor={"#E2E2E2"}
                        my={"18px"}
                      />
                      <Stack spacing={1}>
                        {(featuresList[index] ?? [])?.map((item) => (
                          <ItemInfo key={item} title={t(item)} />
                        ))}
                      </Stack>
                    </Paper>
                  </Grid>
                );
              })}
          </Grid>
        )}
      </Box>
    </Stack>
  );
};

export default PackagePopup;
